(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fs-department-discovery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fs-room-discovery')) {
    customElements.define('fs-room-discovery', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.querySelectorAll('.fs-product-point__panel').forEach((panel) => {
          panel.addEventListener('beforetoggle', (event) => {
            panel.removeAttribute('data-ready');
            const trigger = this.querySelector('.fs-product-point[popovertarget="' + panel.id + '"]');
            trigger?.setAttribute('aria-expanded', String(event.newState === 'open'));
            if (event.newState === 'open') {
              requestAnimationFrame(() => {
                if (!this.isConnected || !panel.matches(':popover-open')) return;
                this.positionPanel(panel);
                if (panel.matches(':popover-open')) panel.setAttribute('data-ready', '');
              });
            }
          }, options);
        });
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const panel = this.querySelector('.fs-product-point__panel:popover-open');
          if (!panel) return;
          event.preventDefault();
          event.stopPropagation();
          panel.hidePopover();
          this.querySelector('button[popovertarget="' + panel.id + '"]')?.focus({ preventScroll: true });
        }, options);
        const reposition = () => this.querySelectorAll('.fs-product-point__panel:popover-open').forEach((panel) => this.positionPanel(panel));
        window.addEventListener('resize', reposition, options);
        document.addEventListener('scroll', reposition, { ...options, capture: true, passive: true });
      }
      positionPanel(panel) {
        if (!panel.matches(':popover-open')) return;
        const trigger = this.querySelector('button[popovertarget="' + panel.id + '"]');
        if (!trigger) return;
        const anchor = trigger.getBoundingClientRect();
        const viewportWidth = document.documentElement.clientWidth;
        const viewportHeight = window.innerHeight;
        if (anchor.bottom < 0 || anchor.top > viewportHeight) { panel.hidePopover(); return; }
        panel.style.setProperty('--panel-width', Math.min(320, viewportWidth - 24) + 'px');
        const width = panel.offsetWidth;
        const height = panel.offsetHeight;
        const left = Math.max(12, Math.min(anchor.left + anchor.width / 2 - width / 2, viewportWidth - width - 12));
        let top = anchor.bottom + 8;
        const above = top + height > viewportHeight - 12;
        if (above) top = anchor.top - height - 8;
        top = Math.max(12, Math.min(top, viewportHeight - height - 12));
        panel.style.setProperty('--panel-left', left + 'px');
        panel.style.setProperty('--panel-top', top + 'px');
        panel.style.setProperty('--panel-origin-x', (anchor.left + anchor.width / 2 - left) + 'px');
        panel.style.setProperty('--panel-origin-y', above ? '100%' : '0%');
        panel.style.setProperty('--panel-enter-y', above ? '7px' : '-7px');
      }
      disconnectedCallback() { this.abortController?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fs-modern-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.fsModernDropdownsBound) return;
  window.fsModernDropdownsBound = true;
  const hoverOpened = new WeakSet();
  const finePointer = window.matchMedia('(min-width:769px) and (hover:hover) and (pointer:fine)');
  const menus = () => document.querySelectorAll('.fs-modern-menu');
  const close = menu => {
    menu.open = false;
    menu.querySelector('summary').setAttribute('aria-expanded', 'false');
    hoverOpened.delete(menu);
  };
  const open = menu => {
    menus().forEach(other => { if (other !== menu) close(other); });
    menu.open = true;
    menu.querySelector('summary').setAttribute('aria-expanded', 'true');
  };
  document.addEventListener('toggle', event => {
    const menu = event.target;
    if (!menu.matches?.('.fs-modern-menu')) return;
    menu.querySelector('summary').setAttribute('aria-expanded', String(menu.open));
    if (menu.open) {
      menus().forEach(other => { if (other !== menu) close(other); });
    } else {
      hoverOpened.delete(menu);
    }
  }, true);
  document.addEventListener('click', event => {
    const summary = event.target.closest('.fs-modern-menu__summary');
    if (summary) {
      const menu = summary.closest('.fs-modern-menu');
      if (event.detail > 0 && hoverOpened.has(menu)) {
        event.preventDefault();
        hoverOpened.delete(menu);
      }
      return;
    }
    if (!event.target.closest('.fs-modern-menu')) menus().forEach(close);
  });
  document.addEventListener('pointerover', event => {
    if (!finePointer.matches || event.pointerType !== 'mouse') return;
    const menu = event.target.closest('.fs-department-nav--modern .fs-modern-menu');
    if (!menu || menu.contains(event.relatedTarget) || menu.open) return;
    hoverOpened.add(menu);
    open(menu);
  });
  document.addEventListener('pointerout', event => {
    if (!finePointer.matches || event.pointerType !== 'mouse') return;
    const menu = event.target.closest('.fs-department-nav--modern .fs-modern-menu');
    if (!menu || menu.contains(event.relatedTarget) || !hoverOpened.has(menu)) return;
    if (!menu.contains(document.activeElement)) close(menu);
  });
  document.addEventListener('focusout', event => {
    const menu = event.target.closest('.fs-department-nav--modern .fs-modern-menu');
    if (menu && !menu.contains(event.relatedTarget)) close(menu);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('.fs-modern-menu[open]');
    if (menu) {
      event.preventDefault();
      close(menu);
      menu.querySelector('summary').focus();
    } else {
      menus().forEach(close);
    }
  });
  document.addEventListener('MobileNav:close', () => menus().forEach(close));
  finePointer.addEventListener('change', () => menus().forEach(close));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fs-room-discovery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fs-room-discovery')) {
    customElements.define('fs-room-discovery', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.querySelectorAll('.fs-product-point__panel').forEach((panel) => {
          panel.addEventListener('beforetoggle', (event) => {
            panel.removeAttribute('data-ready');
            const trigger = this.querySelector('.fs-product-point[popovertarget="' + panel.id + '"]');
            trigger?.setAttribute('aria-expanded', String(event.newState === 'open'));
            if (event.newState === 'open') {
              requestAnimationFrame(() => {
                if (!this.isConnected || !panel.matches(':popover-open')) return;
                this.positionPanel(panel);
                if (panel.matches(':popover-open')) panel.setAttribute('data-ready', '');
              });
            }
          }, options);
        });
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const panel = this.querySelector('.fs-product-point__panel:popover-open');
          if (!panel) return;
          event.preventDefault();
          event.stopPropagation();
          panel.hidePopover();
          this.querySelector('button[popovertarget="' + panel.id + '"]')?.focus({ preventScroll: true });
        }, options);
        const reposition = () => this.querySelectorAll('.fs-product-point__panel:popover-open').forEach((panel) => this.positionPanel(panel));
        window.addEventListener('resize', reposition, options);
        document.addEventListener('scroll', reposition, { ...options, capture: true, passive: true });
      }
      positionPanel(panel) {
        if (!panel.matches(':popover-open')) return;
        const trigger = this.querySelector('button[popovertarget="' + panel.id + '"]');
        if (!trigger) return;
        const anchor = trigger.getBoundingClientRect();
        const viewportWidth = document.documentElement.clientWidth;
        const viewportHeight = window.innerHeight;
        if (anchor.bottom < 0 || anchor.top > viewportHeight) { panel.hidePopover(); return; }
        panel.style.setProperty('--panel-width', Math.min(320, viewportWidth - 24) + 'px');
        const width = panel.offsetWidth;
        const height = panel.offsetHeight;
        const left = Math.max(12, Math.min(anchor.left + anchor.width / 2 - width / 2, viewportWidth - width - 12));
        let top = anchor.bottom + 8;
        const above = top + height > viewportHeight - 12;
        if (above) top = anchor.top - height - 8;
        top = Math.max(12, Math.min(top, viewportHeight - height - 12));
        panel.style.setProperty('--panel-left', left + 'px');
        panel.style.setProperty('--panel-top', top + 'px');
        panel.style.setProperty('--panel-origin-x', (anchor.left + anchor.width / 2 - left) + 'px');
        panel.style.setProperty('--panel-origin-y', above ? '100%' : '0%');
        panel.style.setProperty('--panel-enter-y', above ? '7px' : '-7px');
      }
      disconnectedCallback() { this.abortController?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
